import { LoadingButton, styled } from '@ori-ui/mui';

export const Root = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.spacing(0, 0, 1, 1),
  display: 'flex',
  flexDirection: 'column',
}));

export const Form = styled('form')(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}));

export const Field = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(1),
  position: 'relative',
}));

export const SubmitButton = styled(LoadingButton)(({ theme }) => ({
  marginTop: theme.spacing(3),
}));
